import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

import { Link } from "react-router-dom";

function LatestEvents() {
  const [LatestEvents, setLatestEvents] = useState([]);
  const location = useLocation();

  useEffect(() => {
    document.activeElement.blur();
  }, [location]);


  useEffect(() => {
    const fetchLatestEvents = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/events/latest-three-events`
        );
        if (!response.ok) {
          throw new Error("Events not found");
        }
        const data = await response.json();
        setLatestEvents(data);
      } catch (error) {
        console.error("Error fetching Events:", error);
      }
    };

    fetchLatestEvents();
  }, []);

  const extractFirstSentence = (htmlContent) => {
    if (!htmlContent) return "";

    const parser = new DOMParser();
    // Parse the string as text/html
    const parsedDocument = parser.parseFromString(htmlContent, "text/html");

    const firstParagraph = parsedDocument.querySelector("p");

    if (firstParagraph) {
      // Extract and trim the text content of the paragraph
      let textContent = firstParagraph.textContent.trim();

      const sentences = textContent.match(/[^.!?]+[.!?]/g);

      if (sentences && sentences.length > 0) {
        return sentences[0].trim();
      }
    }

    return "";
  };

  return (
    <section className="media-list-sec blog-inner-list-sec events-inner-list">
      <Container fluid>
        <Row className="flex-center text-center mb-3">
          <Col md={12}>
            <div className="home-community-head">
              <h2 className="common-head greyColor" data-aos="fade-up">
                Related Events
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          {LatestEvents.map((lastestevent) => (
            <Col md={4} key={lastestevent.id}>
              <div className="media-list-card" data-aos="fade-up">
                <Link to={`/events/${lastestevent.slug}`}>
                  <div className="media-list-img">
                    <img
                      src={`${apiUrl.apiUrl}/${lastestevent.card_image}`}
                      className="img-fluid"
                      alt="Premium properties in Dubai"
                    />
                  </div>
                </Link>
                <div className="media-list-content">
                  <h2 className="media-list-heading blog-list-heading">
                    {lastestevent.event_title}
                  </h2>
                  <p className="media-list-para blog-list-para">
                    {extractFirstSentence(lastestevent.description)}
                  </p>

                  <div className="media-list-button-div">
                    <Link
                      to={`/events/${lastestevent.slug}`}
                      className="marquis-roundededge-colored-button"
                      onClick={(e) => e.target.blur()}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default LatestEvents;
